import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'

// Add smooth transition on load
document.documentElement.classList.add('loading')
window.addEventListener('load', () => {
  setTimeout(() => {
    document.documentElement.classList.remove('loading')
    document.documentElement.classList.add('loaded')
  }, 10)
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
